/* Ronini blog — reading progress, table of contents highlighting, gallery thumbnails and copy-link sharing.
   FAQ and update history use native <details>; everything else is plain HTML. */
(() => {
  const root = document.documentElement;
  let queued = false;
  const jobs = [];
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      jobs.forEach((job) => job());
    });
  };

  // Wide tables scroll sideways on phones: make each one a named, keyboard-focusable region so the clipped columns
  // can be reached with the arrow keys (client QA PERF05). Only tables that actually overflow get a tab stop.
  const tables = Array.from(document.querySelectorAll('.rn-table'));
  if (tables.length) {
    const labelTables = () => tables.forEach((wrap, i) => {
      const overflows = wrap.scrollWidth > wrap.clientWidth + 1;
      if (overflows) {
        wrap.setAttribute('tabindex', '0');
        wrap.setAttribute('role', 'region');
        const caption = wrap.querySelector('caption, th');
        const name = caption ? caption.textContent.trim().replace(/\s+/g, ' ').slice(0, 60) : '';
        wrap.setAttribute('aria-label', name ? `Table: ${name} (scrolls sideways)` : `Table ${i + 1} (scrolls sideways)`);
      } else if (wrap.getAttribute('tabindex') === '0') {
        wrap.removeAttribute('tabindex');
        wrap.removeAttribute('role');
        wrap.removeAttribute('aria-label');
      }
    });
    labelTables();
    let resizeTimer = null;
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(labelTables, 150); });
  }

  const progress = document.querySelector('[data-rn-progress]');
  if (progress) {
    document.body.appendChild(progress);
    const fill = progress.firstElementChild;
    jobs.push(() => {
      const max = root.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      fill.style.transform = `scaleX(${ratio})`;
    });
  }

  // The table of contents is the shared section nav (assets/rn-section-nav.js).

  if (jobs.length) {
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    // Lazy images push headings down as they load, so recheck when the page grows.
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(document.body);
    queue();
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.rn-gallery__thumb');
    if (thumb) {
      const gallery = thumb.closest('[data-rn-gallery]');
      const main = gallery && gallery.querySelector('[data-rn-gallery-main]');
      if (main) {
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('.rn-gallery__thumb').forEach((item) => {
          item.classList.toggle('is-active', item === thumb);
          item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
        });
      }
      return;
    }

    const button = event.target.closest('[data-rn-copy]');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.getAttribute('data-rn-copy')).then(() => {
      button.classList.add('is-copied');
      setTimeout(() => button.classList.remove('is-copied'), 1600);
    });
  });
})();
